module.exports = __webpack_public_path__ + "img/file-icon-other.c4e6268a.svg";